/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import styled from "@emotion/styled";
import BackgroundImage from "../3-utils/BackgroundImage";
import { doGoToArticle } from "../4-redux/actions";
import { connect } from "react-redux";

function ArticlePreview({ title, content, backgroundImage, id, goToArticle }) {
  return (
    <Container src={backgroundImage.fields.file.url}>
      <Title>
        <a onClick={() => goToArticle(id)}>{title}</a>
      </Title>
      <Content dangerouslySetInnerHTML={{ __html: content }} />
    </Container>
  );
}

const actions = {
  goToArticle: doGoToArticle,
}

export default connect(null, actions)(ArticlePreview)

const Container = styled(BackgroundImage)`
  min-height: 500px;
  border: 4px solid grey;
  border-bottom: none;
  border-left: none;
  margin-bottom: 4em;
  border-radius: 0 60px 0 0;
  position: relative;
`;

const Title = styled.h1`
  position: absolute;
  top: -65px;
  left: 0;
  background-color: var(--background);
  padding: 0.2em;
  font-size: 40px;
  padding-right: 0.5em;
  border-radius: 0 40px 40px 0;
  @media (max-width: 600px) {
    font-size: 24px;
    top: -35px;
  }
`;

const Content = styled.p`
  font-size: 20px;
  padding: 1em 4em 1em 0;
  line-height: 1.4em;
  color: #c2c2c2;
  overflow: hidden;

  iframe {
    width: 200%;
    margin: 1em 0;
    outline: none;
  }

  @media (max-width: 600px) {
    font-size: 16px;
    padding: 0 1em 0 0;
  }
`;
